module.exports = __webpack_public_path__ + "media/images/icons/date-a-conocer-b265989c45429207c1bed600e70802cf.svg";